import { post } from "../../service/api";

const AskAiQuestion = async (question) => {
  try {
    const response = await post(`/ai/ask`, { question });
    return response;
  } catch (error) {
    console.error("Error AskAiQuestion:", error);
    throw error;
  }
};

export default AskAiQuestion;
